export default "__VITE_ASSET__B0N4vnSQ__"